import { entryModeAtom } from '@store/atoms'
import { isDeviceMobile } from '@utils/mobile'

export type DocumentFlowKey = 'selectDocument' | 'uploadDoc' | 'uploadSuccess'

export type DocumentFlowStep = {
	id: number
	key: DocumentFlowKey
	label: string
}

// ---- substep tecnico (serve per wizard: dialog/form)
export type ContactDialogSubStep = {
	id: number
	value: 'contactData'
	type: 'dialog' | 'form'
	label: string
	completed: boolean
	required: boolean
}

// ---- substep documento (CI/CF/Reddito)
export type ContactDocSubStep = {
	id: number
	value: string // '1' | '2' | '3' (oppure string se vuoi flessibile)
	label: string
	completed: boolean
	required: boolean
	documents: DocumentFlowStep[] // può essere [] ma NON null/undefined
	type?: 'dialog' | 'form'
}

// ---- union finale: un substep può essere tecnico o documento
export type SubStepContact = ContactDialogSubStep | ContactDocSubStep

// ---- option (Fotografa / Allega / Manuale)
export interface ContactChoiceOption {
	id: number
	value: string
	label: string
	subLabel?: string
	imageDesk?: string
	imageMob?: string
	subSteps?: SubStepContact[]
}

export interface StepOptionContact {
	id: number
	value: string
	label: string
	type: 'insert' | 'contact' | 'preview' // ecc.
	subSteps?: SubStepContact[]
}

//STEP1 - CONTACT SUBSTEPS NAME
export const DocumentMode = {
	FOTOGRAFA: '1',
	ALLEGA: '2',
	MANUALE: '3',
} as const

export type DocumentMode = (typeof DocumentMode)[keyof typeof DocumentMode]
/* 
export const AnagraficaSubsteps = {
	OTP: 0,
	CITTADINANZA: 1,
	ABITAZIONE: 2,
	DOCUMENTI: 3,
} as const
 */
//STEP2 -  SUBSTEPS NAME
export const AnagraficaSubsteps = {
	CITTADINANZA: 0,
	ABITAZIONE: 1,
	DOCUMENTI: 2,
} as const

export type Actions =
	(typeof AnagraficaSubsteps)[keyof typeof AnagraficaSubsteps]

////navigazione

export type EntryMode =
	| 'INSERIMENTO_MANUALE'
	| 'FOTOGRAFA_DOCUMENTI'
	| 'ALLEGA_DOCUMENTI'
	| 'SERVIZI_FACOLTATIVI'
	| null

export type DocumentKind = 'FRONTE_RETRO' | 'SINGOLO'

export type OtpChoice = 'OTP' | 'NOOTP' | null

const COMMON_ANAGRAFICA_FLOW: FlowStep[] = [
	'DATI_ANAGRAFICI:CITTADINANZA_E_STATO_CIVILE',
	'DATI_ANAGRAFICI:ABITAZIONE',
	'DATI_ANAGRAFICI:DOCUMENTO_D_IDENTITA',
]

const COMMON_FINAL_FLOW: FlowStep[] = [
	'PROFESSIONE:OCCUPAZIONE',
	'PROFESSIONE:REDDITO',
	'PROFESSIONE:PEP',
	'SERVIZI_FACOLTATIVI:PREFERENZE_ASSICURATIVE',
	'SERVIZI_FACOLTATIVI:BENEFICIARIO',
	'SERVIZI_FACOLTATIVI:SOGGETTO_TERZO',
	'SERVIZI_FACOLTATIVI:IDENTINET',
	'RIEPILOGO:INVIO_RICHIESTA',
]

export type FlowStep =
	| 'CONTATTI:DATI_DI_CONTATTO'
	| 'CONTATTI:SELEZIONA_DOCUMENTI'
	| 'CONTATTI:SELEZIONA_UN_DOCUMENTO'
	| 'CONTATTI:FOTOGRAFA_O_ALLEGA_UN_DOCUMENTO'
	| 'CONTATTI:ALLEGA_UN_DOCUMENTO'
	| 'CONTATTI:ANTEPRIMA_DEL_DOCUMENTO'
	| 'CONTATTI:FOTOGRAFA_O_ALLEGA_IL_FRONTE'
	| 'CONTATTI:FOTOGRAFA_O_ALLEGA_IL_RETRO'
	| 'CONTATTI:ALLEGA_IL_RETRO'
	| 'CONTATTI:ALLEGA_IL_FRONTE'
	| 'CONTATTI:ALLEGA_RETRO_DOCUMENTO'
	| 'CONTATTI:ANTEPRIMA_DOCUMENTO_RETRO'
	| 'CONTATTI:ANTEPRIMA_DOCUMENTO_FRONTE'
	| 'CONTATTI:LE_IMMAGINI_SONO_PRONTE'
	| 'CONTATTI:INSERISCI_I_DATI'
	| 'CONTATTI:VERIFICA_I_TUOI_DATI'
	| 'CONTATTI:INSERISCI_I_DATI_MANCANTI'
	| 'DATI_ANAGRAFICI:RECUPERA_I_TUOI_DATI'
	| 'DATI_ANAGRAFICI:CODICE_OTP'
	| 'DATI_ANAGRAFICI:CITTADINANZA_E_STATO_CIVILE'
	| 'DATI_ANAGRAFICI:ABITAZIONE'
	| 'DATI_ANAGRAFICI:DOCUMENTO_D_IDENTITA'
	| 'PROFESSIONE:OCCUPAZIONE'
	| 'PROFESSIONE:REDDITO'
	| 'PROFESSIONE:PEP'
	| 'SERVIZI_FACOLTATIVI:PREFERENZE_ASSICURATIVE'
	| 'SERVIZI_FACOLTATIVI:BENEFICIARIO'
	| 'SERVIZI_FACOLTATIVI:SOGGETTO_TERZO'
	| 'SERVIZI_FACOLTATIVI:IDENTINET'
	| 'RIEPILOGO:INVIO_RICHIESTA'

// const COMMON_FINAL_FLOW: FlowStep[] = [
// 	'DATI_ANAGRAFICI:ABITAZIONE',
// 	'DATI_ANAGRAFICI:DOCUMENTO_D_IDENTITA',
// 	'PROFESSIONE:OCCUPAZIONE',
// 	'PROFESSIONE:REDDITO',
// 	'PROFESSIONE:PEP',
// 	'SERVIZI_FACOLTATIVI:PREFERENZE_ASSICURATIVE',
// 	'SERVIZI_FACOLTATIVI:BENEFICIARIO',
// 	'SERVIZI_FACOLTATIVI:SOGGETTO_TERZO',
// 	'SERVIZI_FACOLTATIVI:IDENTINET',
// 	'RIEPILOGO:INVIO_RICHIESTA',
// ]
/* 
export function buildFlow(params: {
	entryMode: EntryMode
	hasFiscalCode: boolean
}): FlowStep[] {
	const { entryMode, hasFiscalCode } = params

	console.log("BUILD FLOW",entryMode)

	switch (entryMode) {
		case 'INSERIMENTO_MANUALE':
			return [
				// 'CONTATTI:INSERISCI_I_DATI',
				'CONTATTI:DATI_DI_CONTATTO',
				hasFiscalCode
	
				? 'DATI_ANAGRAFICI:RECUPERA_I_TUOI_DATI'
				:
				'DATI_ANAGRAFICI:CITTADINANZA_E_STATO_CIVILE',
				
				...COMMON_FINAL_FLOW]

		case 'GENERA_OTP':
			return [
				'CONTATTI:DATI_DI_CONTATTO',
				hasFiscalCode
					? 'DATI_ANAGRAFICI:RECUPERA_I_TUOI_DATI'
					: 'DATI_ANAGRAFICI:CODICE_OTP',
				...COMMON_FINAL_FLOW,
			]

		case 'FOTOGRAFA_DOCUMENTI':
			return [
				'CONTATTI:SELEZIONA_UN_DOCUMENTO',
			   	'CONTATTI:FOTOGRAFA_O_ALLEGA_UN_DOCUMENTO',
				'CONTATTI:ANTEPRIMA_DEL_DOCUMENTO',
				'CONTATTI:FOTOGRAFA_O_ALLEGA_IL_FRONTE',
				'CONTATTI:LE_IMMAGINI_SONO_PRONTE',
				'CONTATTI:VERIFICA_I_TUOI_DATI',
				'CONTATTI:INSERISCI_I_DATI_MANCANTI',
				...COMMON_FINAL_FLOW,
			]

		case 'ALLEGA_DOCUMENTI':
			return [
				'CONTATTI:SELEZIONA_UN_DOCUMENTO',
				'CONTATTI:ALLEGA_UN_DOCUMENTO',
				'CONTATTI:ANTEPRIMA_DEL_DOCUMENTO',
				'CONTATTI:ALLEGA_IL_FRONTE',
				'CONTATTI:LE_IMMAGINI_SONO_PRONTE',
				'CONTATTI:VERIFICA_I_TUOI_DATI',
				'CONTATTI:INSERISCI_I_DATI_MANCANTI',
				...COMMON_FINAL_FLOW,
			]

		default:
			return []
	}
}
 */

export function buildFlow(params: {
	entryMode: EntryMode | null
	documentKind?: DocumentKind
}): FlowStep[] {
	const { entryMode,  documentKind = 'FRONTE_RETRO' } = params

		const isDocumentoSingolo = documentKind === 'SINGOLO'
	

	console.log("MODUS",entryMode, "docreddito",isDocumentoSingolo)

	if (!entryMode) return []

	let contactFlow: FlowStep[] = []

	switch (entryMode) {
		case 'INSERIMENTO_MANUALE':
			contactFlow = ['CONTATTI:DATI_DI_CONTATTO']
			break

		case 'FOTOGRAFA_DOCUMENTI':
			contactFlow = isDocumentoSingolo
				? [
						'CONTATTI:SELEZIONA_UN_DOCUMENTO',
						'CONTATTI:FOTOGRAFA_O_ALLEGA_UN_DOCUMENTO',
						'CONTATTI:ANTEPRIMA_DEL_DOCUMENTO',
						'CONTATTI:VERIFICA_I_TUOI_DATI',
					]
				: [
						'CONTATTI:SELEZIONA_UN_DOCUMENTO',
						'CONTATTI:FOTOGRAFA_O_ALLEGA_UN_DOCUMENTO',
						'CONTATTI:ANTEPRIMA_DEL_DOCUMENTO',
						'CONTATTI:FOTOGRAFA_O_ALLEGA_IL_FRONTE',
						'CONTATTI:LE_IMMAGINI_SONO_PRONTE',
						'CONTATTI:VERIFICA_I_TUOI_DATI',
						'CONTATTI:INSERISCI_I_DATI_MANCANTI',
					]
			break

		case 'ALLEGA_DOCUMENTI':
			contactFlow = isDocumentoSingolo
				? [
						'CONTATTI:SELEZIONA_UN_DOCUMENTO',
						'CONTATTI:ALLEGA_UN_DOCUMENTO',
						'CONTATTI:ANTEPRIMA_DEL_DOCUMENTO',
						'CONTATTI:VERIFICA_I_TUOI_DATI',
					]
				: [
						'CONTATTI:SELEZIONA_UN_DOCUMENTO',
						'CONTATTI:ALLEGA_UN_DOCUMENTO',
						'CONTATTI:ANTEPRIMA_DEL_DOCUMENTO',
						'CONTATTI:ALLEGA_IL_FRONTE',
						'CONTATTI:LE_IMMAGINI_SONO_PRONTE',
						'CONTATTI:VERIFICA_I_TUOI_DATI',
						'CONTATTI:INSERISCI_I_DATI_MANCANTI',
					]
			break
	}

	return [...contactFlow, ...COMMON_ANAGRAFICA_FLOW, ...COMMON_FINAL_FLOW]
}
export function getNextFlowStep(
	flow: FlowStep[],
	current: FlowStep | null
): FlowStep | null {
	if (!current) return flow[0] ?? null

	const index = flow.indexOf(current)
	if (index === -1) return null

	return flow[index + 1] ?? null
}

export function formatFlowStepLabel(step: FlowStep | null,	selectedDoc?: number): string {
	//console.log('NAVIGATION STEPS', step)
	if (!step) return ''
	const isDocumentoReddito = String(selectedDoc) === '3'

	console.log( "docreddito",isDocumentoReddito)

	const [section, sub] = step.split(':')

	const sectionMap: Record<string, string> = {
		CONTATTI: 'Contatti',
		DATI_ANAGRAFICI: 'Dati anagrafici',
		PROFESSIONE: 'Professione',
		SERVIZI_FACOLTATIVI: 'Servizi facoltativi',
		RIEPILOGO: 'Riepilogo',
	}

	const subMap: Record<string, string> = {
		DATI_DI_CONTATTO: 'Dati di contatto',
		SELEZIONA_DOCUMENTI: 'Seleziona documenti',
		SELEZIONA_UN_DOCUMENTO: 'Seleziona documento',
		FOTOGRAFA_O_ALLEGA_UN_DOCUMENTO: isDeviceMobile()
			? 'Fotografa o allega il documento'
			: 'Allega il documento',
		ALLEGA_UN_DOCUMENTO: isDeviceMobile()
			? 'Fotografa o allega il documento'
			: 'Allega il documento',
		ALLEGA_IL_FRONTE: isDeviceMobile()
			? 'Fotografa o allega il fronte del documento'
			: 'Allega il fronte del documento',
		ALLEGA_IL_RETRO: isDeviceMobile()
			? 'Fotografa o allega il retro del documento'
			: 'Allega il retro del documento',
		ANTEPRIMA_DEL_DOCUMENTO: 'Anteprima del documento',
		FOTOGRAFA_O_ALLEGA_IL_FRONTE: 'Fotografa o allega il fronte',
		FOTOGRAFA_O_ALLEGA_IL_RETRO: 'Fotografa o allega il retro',
		LE_IMMAGINI_SONO_PRONTE: 'Le immagini sono pronte',
		VERIFICA_I_TUOI_DATI: 'Verifica dati',
		INSERISCI_I_DATI: 'Inserisci i dati',
		INSERISCI_I_DATI_MANCANTI: 'Inserisci i dati mancanti',
		RECUPERA_I_TUOI_DATI: 'Recupera i tuoi dati',
		CODICE_OTP: 'Codice OTP',
		CITTADINANZA_E_STATO_CIVILE: 'Cittadinanza e Stato civile',
		ABITAZIONE: 'Abitazione',
		DOCUMENTO_D_IDENTITA: "Documento d'identità",
		OCCUPAZIONE: 'Occupazione',
		REDDITO: 'Reddito',
		PEP: 'PEP',
		PREFERENZE_ASSICURATIVE: 'Preferenze assicurative',
		BENEFICIARIO: 'Beneficiario',
		SOGGETTO_TERZO: 'Soggetto terzo',
		IDENTINET: 'Identinet',
		INVIO_RICHIESTA: 'Invio richiesta',
	}

	return `${sectionMap[section]}: ${subMap[sub]}`
}
